import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { DepartmentPosition } from '../department-model';
import { AvatarPipe } from '../../../../../../ui-components/pipes/avatar/avatar.pipe';
import { TooltipDirective } from '../../../../../../ui-components/lib/tooltip/tooltip.directive';

@Component({
  selector: 'lib-department-position-card',
  imports: [TranslocoPipe, AvatarPipe, TooltipDirective],
  template: `
    <div
      class="flex flex-col gap-sm p-md border border-neutral-200 rounded-md bg-white"
      [attr.data-testid]="'position-card-' + position().id">
      <div class="flex items-center gap-sm min-w-0">
        <span
          class="text-sm font-semibold text-neutral-900 truncate"
          libTooltip
          [libTooltip]="position().name"
          [hasCloseIcon]="false"
          placement="top"
          toolTipAction="mouseenter"
          [toolTipClass]="nameTooltipClass">
          {{ position().name }}
        </span>
        @if (statusLabel()) {
          <span
            class="px-sm rounded-sm bg-neutral-100 text-neutral-700 text-xs whitespace-nowrap">
            {{ statusLabel() }}
          </span>
        }
      </div>
      @if (position().incumbent; as incumbent) {
        <div class="flex items-center gap-sm text-xs text-neutral-700">
          @if (incumbent.image) {
            <img
              [src]="incumbent.image.url"
              [alt]="incumbent.name"
              width="20"
              height="20"
              class="rounded-full size-5" />
          } @else {
            <span
              class="rounded-full bg-primary-50 text-primary-500 flex justify-center items-center size-5">
              {{ incumbent.name | avatar }}
            </span>
          }
          <span>{{ incumbent.name }}</span>
        </div>
      } @else {
        <span class="text-xs text-neutral-500">
          {{ 'department_position_no_assignee_label' | transloco }}
        </span>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DepartmentPositionCardComponent {
  readonly position = input.required<DepartmentPosition>();
  protected readonly nameTooltipClass =
    'bg-white p-md rounded-lg shadow-lg !w-auto tooltip-arrow tooltip-arrow-top';

  protected readonly statusLabel = computed(
    () =>
      this.position().position_status?.label ??
      this.position().state?.label ??
      ''
  );
}
